import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="reload-frame"
export default class extends Controller {
  static values = { timeout: { type: Number, default: 30_000 } };

  connect() {
    // this.timeoutValue = setTimeout(() => this.reload(), this.timeoutValue)
  }

  disconnect() {
    this.timeoutValue && clearTimeout(this.timeoutValue);
  }

  reload() {
    this.element.closest("turbo-frame").reload();
  }
}
